export default __webpack_public_path__ + "static/media/pirateAnimation.6a0c3fc5.gif";